import React from 'react';

export const name = 'flag-SK';

export const FlagSK = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_433)">
      <mask
        id="mask0_2_433"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_433)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#EEEEEE"
        />
        <path
          d="M12 24C13.9351 23.9998 15.8415 23.5315 17.5565 22.6353C19.2715 21.739 20.7443 20.4413 21.8494 18.8528C22.9545 17.2642 23.659 15.432 23.9029 13.5124C24.1467 11.5927 23.9228 9.64252 23.25 7.82812H0.750005C0.0772536 9.64252 -0.14673 11.5927 0.0971498 13.5124C0.34103 15.432 1.04554 17.2642 2.15061 18.8528C3.25567 20.4413 4.72852 21.739 6.44353 22.6353C8.15855 23.5315 10.0649 23.9998 12 24Z"
          fill="#0052B4"
        />
        <path
          d="M12 24C14.4501 23.9997 16.8414 23.2494 18.8525 21.85C20.8636 20.4506 22.3982 18.4691 23.25 16.1719H0.75C1.60179 18.4691 3.13636 20.4506 5.14748 21.85C7.15861 23.2494 9.54989 23.9997 12 24Z"
          fill="#D80027"
        />
        <path
          d="M3.10312 6.78278V12.7687C3.10312 16.1718 7.55156 17.2218 7.55156 17.2218C7.55156 17.2218 12 16.1718 12 12.7687V6.78278H3.10312Z"
          fill="#EEEEEE"
        />
        <path
          d="M4.14845 6.78278V12.7687C4.14734 13.1605 4.2372 13.5473 4.41095 13.8984H10.6922C10.8666 13.5475 10.9565 13.1606 10.9547 12.7687V6.78278H4.14845Z"
          fill="#D80027"
        />
        <path
          d="M9.63751 10.9547H8.07189V9.91406H9.1172V8.86875H8.07189V7.82812H7.03126V8.86875H5.98595V9.91406H7.03126V10.9547H5.46564V12H7.03126V13.0453H8.07189V12H9.63751V10.9547Z"
          fill="#EEEEEE"
        />
        <path
          d="M5.83595 15.3563C6.37285 15.6868 6.94927 15.9482 7.55157 16.1344C7.90313 16.0266 8.59688 15.7782 9.26719 15.3563C9.86705 15.0126 10.3602 14.5097 10.6922 13.9032C10.3843 13.6838 10.0156 13.5658 9.63751 13.5657C9.49688 13.5657 9.35626 13.5844 9.22501 13.6126C9.08218 13.2878 8.84785 13.0115 8.55071 12.8176C8.25357 12.6237 7.90641 12.5204 7.55157 12.5204C7.19673 12.5204 6.84957 12.6237 6.55243 12.8176C6.25529 13.0115 6.02101 13.2878 5.87813 13.6126C5.74285 13.5813 5.60448 13.5656 5.46563 13.5657C5.07188 13.5657 4.71095 13.6876 4.41095 13.8985C4.74221 14.5067 5.23543 15.0113 5.83595 15.3563Z"
          fill="#0052B4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_433">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
